import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "table"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_button = _resolveComponent("el-button");
  const _component_SkuVxeTable = _resolveComponent("SkuVxeTable");
  const _component_el_row = _resolveComponent("el-row");
  return _openBlock(), _createBlock(_component_el_row, null, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 24
    }, {
      default: _withCtx(() => _cache[7] || (_cache[7] = [_createElementVNode("div", {
        class: "title m-l-20"
      }, "SKU列表", -1)])),
      _: 1,
      __: [7]
    }), (_openBlock(), _createBlock(_component_el_col, {
      span: 24,
      class: "m-l-20",
      key: _ctx.data.isRefrsh
    }, {
      default: _withCtx(() => [_ctx.data.isDisabled == 1 ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        type: "text",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.btnClickCom('add'))
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("新增行")])),
        _: 1,
        __: [8]
      })) : _createCommentVNode("", true), _ctx.data.isDisabled == 1 ? (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        type: "text",
        onClick: _cache[1] || (_cache[1] = $event => _ctx.btnClickCom('del'))
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("删除行")])),
        _: 1,
        __: [9]
      })) : _createCommentVNode("", true), _createVNode(_component_el_button, {
        type: "text",
        onClick: _cache[2] || (_cache[2] = $event => _ctx.btnClickCom('mul'))
      }, {
        default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("批量编辑")])),
        _: 1,
        __: [10]
      })]),
      _: 1
    })), _createElementVNode("div", _hoisted_1, [_createVNode(_component_SkuVxeTable, {
      editId: _ctx.data.transmitEditId,
      "onUpdate:editId": _cache[3] || (_cache[3] = $event => _ctx.data.transmitEditId = $event),
      transmitData: _ctx.data.transmitData,
      "onUpdate:transmitData": _cache[4] || (_cache[4] = $event => _ctx.data.transmitData = $event),
      notice: _ctx.data.noticeCom,
      "onUpdate:notice": _cache[5] || (_cache[5] = $event => _ctx.data.noticeCom = $event),
      clickEvent: _ctx.data.clickEvent,
      "onUpdate:clickEvent": _cache[6] || (_cache[6] = $event => _ctx.data.clickEvent = $event),
      onTransmitTableDate: _ctx.transmitTableDate
    }, null, 8, ["editId", "transmitData", "notice", "clickEvent", "onTransmitTableDate"])])]),
    _: 1
  });
}